import { WarrantyProcessEffect } from "./warranty-process.effect";

export const effects: any[] = [
  WarrantyProcessEffect
];
